import React, { useState, useEffect } from 'react';
import axios from 'axios';



function BlogCardQiita() {
    const [post, setPosts] = useState([])

    const url = "https://qiita.com/api/v2/users/koneko59/items?page=1&per_page=10";
    useEffect(() => {
        axios.get(url).then(res => {
            console.log(res.data)
            setPosts(res.data)
        });
    }, [])

    return (
        <div className="h-full w-full min-w-0 flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow transition-shadow duration-300 hover:shadow-xl">
            <div className="w-full min-w-0 flex flex-col justify-between p-4 leading-normal">
                <a className="mb-2 text-2xl font-bold tracking-tight text-gray-900" href="https://qiita.com/koneko59">
                    Qiita
                </a >

                {post.map((data) => {
                    return (
                        <div key={data.url} className="w-full min-w-0 text-left py-1 px-4">
                            <p className="text-black">
                                <a href={data.url} target="_blank" rel="noopener noreferrer" className="nav-underline inline-block max-w-full break-words font-medium text-black"> {data.title} </a>
                            </p>

                            <div className="flex flex-wrap items-center">
                                {data.tags.map((tag) => {
                                    return (<p key={tag.name} className="bg-gray-100 text-gray-800 text-xs font-medium mr-2 mb-1 px-2.5 py-0.5 rounded">{tag.name}</p>)
                                })}
                            </div>
                            <div className="flex items-center">
                                <p>{new Date(data.updated_at).toLocaleDateString()}</p>
                                <i className="fa-solid fa-folder px-2"></i>
                                <p>{data.stocks_count}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>);
}
export default BlogCardQiita;